import { req } from "@/api/api_request";

// 获取巡查线路列表
export function getPatrolRouteList({group_id, name, page, size }) {
  let url = `inspection/get-road-list?group_id=${group_id}`;
  if (name) {
    url += `&name=${name}`;
  }
  if (page) {
    url += `&page=${page}`;
  }
  if (size) {
    url += `&size=${size}`;
  }
  return req.get(url);
}

// 新建巡查线路
export function addPatrolRoute(params) {
  let url = `inspection/add-road`;
  return req.post(url, params);
}

// 编辑巡查线路
export function updatePatrolRoute(params) {
  let url = `inspection/update-road`;
  return req.post(url, params);
}

// 删除巡查线路
export function deletePatrolRoute(id) {
  let url = `inspection/delete-road?road_id=${id}`;
  return req.post(url);
}
